// Punch location names are geocoded at punch time and stored with the punch
// (location_name), so reports only format what the API returns - no lookups here.
export const formatReportLocation = (name, fallback) => {
  const value = name || fallback;
  if (value && typeof value === "object") {
    if (value.location_name || value.name) return String(value.location_name || value.name);
    const lat = value.latitude ?? value.lat;
    const lng = value.longitude ?? value.lng ?? value.lon;
    return lat != null && lng != null ? `${lat}, ${lng}` : "-";
  }
  return String(value ?? "").trim() || "-";
};
